interface DefaultPagingConfigInterface {
    defaultPageNumber: number;
    defaultItemsPerPage: number;
    filters: {
        perPage: string;
        page: string;
    };
}

const DefaultPagingConfig: DefaultPagingConfigInterface = {
    defaultPageNumber: 1,
    defaultItemsPerPage: 20,
    filters: {
        perPage: 'per_page',
        page: 'page',
    },
};

export interface Pagination {
    pageNumber: number;
    totalItems: number;
    itemsPerPage: number;
    paginationControlLinks: string[] | undefined;
    uiControlsRenderer(current: any, type: any, originalElement: any): string;
    getPagingFilters(page: number, itemsPerPage?: number): { [key: string]: number };
}
export default class PaginationHandler implements Pagination {
    private defaultPagingConfig: DefaultPagingConfigInterface;

    pageNumber: number;

    totalItems: number;

    itemsPerPage: number;

    paginationControlLinks: string[] | undefined;

    constructor({
        'x-page': pageNumber,
        'x-total': totalItems,
        'x-per-page': itemsPerPage,
        links,
    }: {
        'x-page': string;
        'x-total': string;
        'x-per-page': string;
        links: string | undefined;
    }) {
        this.pageNumber = Number(pageNumber) || DefaultPagingConfig.defaultPageNumber;
        this.totalItems = Number(totalItems) || 0;
        this.itemsPerPage = Number(itemsPerPage) || DefaultPagingConfig.defaultItemsPerPage;
        this.paginationControlLinks = links ? links.split(',') : undefined;
        this.defaultPagingConfig = DefaultPagingConfig;
    }

    public getPagingFilters = (page: number, itemsPerPage?: number): { [key: string]: number } => {
        return {
            [this.defaultPagingConfig.filters.page]: page || this.defaultPagingConfig.defaultPageNumber,
            [this.defaultPagingConfig.filters.perPage]: itemsPerPage || this.defaultPagingConfig.defaultItemsPerPage,
        };
    };

    public uiControlsRenderer(current: any, type: any, originalElement: any): string {
        switch (type) {
            case 'prev':
                return 'Previous';
            case 'next':
                return 'Next';
            default:
                return originalElement;
        }
    }
}
